import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {SortTableCell} from '../../../../../shared/models/sort-table/cell-classes';
import {SortTableInstanceService} from '../../../../../core/services/sort-table-instance.service';

@Component({
    selector: 'motn-base-cell',
    template: './base-cell.component.html',
    styleUrls: ['./base-cell.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export abstract class BaseCellComponent {
  cell: SortTableCell;


  constructor(
    protected tableService?: SortTableInstanceService,
  ) {}


  ngOnInit(): void {
    if (this.cell?.onInitCallback) {
      this.cell.onInitCallback();
    }

    this.onInit();
  }


  protected onInit(): void {}
}
